/* import __COLOCATED_TEMPLATE__ from './refer-client-modal.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { closeModal } from 'sh-www/utils/modal-controls';

const CLASS_NAME = 'SH-c-refer-client-modal';

class ReferClientModal extends Component {
  @service('state-managers/application') applicationStateManager;
  @service session;

  get className() {
    return CLASS_NAME;
  }

  @action
  handleClose() {
    closeModal(this);
  }

  @action
  handleComplete() {
    this.applicationStateManager.addToast('Thank you! Your referral has been submitted.');
    closeModal(this);
  }
}

export default ReferClientModal;
